import React, { createContext, useState, useContext } from "react";

const StructureContext = createContext();

export const StructureProvider = ({ children }) => {
  const [highlightData, setHighlightData] = useState(null);

  return (
    <StructureContext.Provider
      value={{
        highlightData,
        setHighlightData,
      }}
    >
      {children}
    </StructureContext.Provider>
  );
};

export const useStructureContext = () => useContext(StructureContext);
